import { DatePicker } from '@mui/x-date-pickers'
import { Grid } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import { PickerChangeHandlerContext } from '@mui/x-date-pickers/models'

export interface DateRangeProps {
  initialRange?: Array<string | undefined>
  onChange(range: [string?, string?]): void
}

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DateRange = ({ initialRange: [dateFrom, dateTo] = [], onChange }: DateRangeProps) => {
  const handleDateFromChange = (value: Dayjs | null, ctx: PickerChangeHandlerContext<unknown>) => {
    if (ctx.validationError) {
      return
    }
    onChange([value?.format(DATE_FORMAT), dateTo])
  }

  const handleDateToChange = (value: Dayjs | null, ctx: PickerChangeHandlerContext<unknown>) => {
    if (ctx.validationError) {
      return
    }
    onChange([dateFrom, value?.format(DATE_FORMAT)])
  }

  return (
    <Grid container flexDirection="row" spacing={2}>
      <Grid item xs={12} md={6}>
        <DatePicker
          value={dateFrom ? dayjs(dateFrom) : undefined}
          maxDate={dateTo ? dayjs(dateTo) : dayjs()}
          label="Период с"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            },
          }}
          onChange={handleDateFromChange}
          views={['year', 'month', 'day']}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePicker
          value={dateTo ? dayjs(dateTo) : undefined}
          maxDate={dayjs()}
          minDate={dateFrom ? dayjs(dateFrom) : undefined}
          label="Период по"
          onChange={handleDateToChange}
          views={['year', 'month', 'day']}
        />
      </Grid>
    </Grid>
  )
}
